<div class="modal-header">
  <div class="title">
    <h2 class="modal-title-prefix"><span translate="EDOKUMENT.SEND.SINGULAR"></span></h2>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">


  <div class="row detail-table">
    <div class="col-md-12">
      <yt-fw-default-table *ngIf="modelData!=null && modelData.MainList!=null"
                           [Config]="Config"
                           [Items]="items"
                           [TableColumns]="modelData.MainList.TableColumns"
                           [Condensed]="CondensedTable"
                           [ShowLoader]="MainItemsLoading"
                           (DeleteItemClicked)="deleteItem($event)">
      </yt-fw-default-table>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-3">
      <div class="btn-group ml-auto mr-2">
        <input #file type="file" accept="application/pdf" multiple (change)="onFileChange($event)" style="display:none" />
        <button type="button" class="btn btn-outline-primary" id="btnAddAttachment" (click)="file.click()" [disabled]="!file">
          <i class="fas fa-solid fa-paperclip"></i>
          <span translate="EDOKUMENT.ATTACHMENT.ADD"></span>
        </button>
      </div>
    </div>
  </div>
  <!-- <div class="row mt-3" *ngIf="this.Parameters[2].Value == 'ko'">
    <div class="col-md-8">
      <yt-fw-date-picker-popup name="txtDatumSmanjenja"
                               #dtpDatumSmanjenja
                               [Label]="'FAKDOKUMENT.DATUMSMANJENJA.SINGULAR'"
                               [ngClass]="{
                'is-invalid': submitted && !dtpDatumSmanjenja?.value
              }">
      </yt-fw-date-picker-popup>

      <div class="form-error" *ngIf="submitted && !dtpDatumSmanjenja?.value">
        <span class="error-message" *ngIf="!dtpDatumSmanjenja?.value"><span translate="{{'FAKDOKUMENT.DATUMSMANJENJA.VALIDATION.REQUIRED'}}"></span></span>
      </div>
    </div>
  </div> -->


</div>
<div class="modal-footer">
  <button type="submit" class="btn btn-primary" id="btnSendEdokument" (click)="SendEDokument()">
    <span translate="EDOKUMENT.SENDEUINVOICE.ACTION"></span>
    <span *ngIf="loadingSendEUInvoice" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
  </button>
  <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span translate="FW.ACTION.CLOSE.ACTION"></span></button>
</div>
